import { Box, Button, Icon, Paper, useTheme, Typography } from '@mui/material';
import { useAppThemeContext } from '../../contexts';

import { Environment } from '../../environment';

interface IFerramentasDaListagemProps {
  aoClicarEmVoltar: () => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  aoClicarEmNovo: () => void;
  textoBotaoDesativados?: string;
  mostrarBotaoDesativados?: boolean;
  aoClicarEmDesativados?: () => void;
}
export const FerramentasDaListagem: React.FC<IFerramentasDaListagemProps> = ({
  aoClicarEmVoltar,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  aoClicarEmNovo,
  textoBotaoDesativados = 'Desativados',
  mostrarBotaoDesativados = false,
  aoClicarEmDesativados,
}) => {
  const theme = useTheme();
  const { themeName } = useAppThemeContext();

  return (
    <Box
      component={Paper}
      height={theme.spacing(5)}
      marginX={1}
      padding={1}
      paddingX={2}
      display="flex"
      gap={1}
      alignItems="center"
    >
      <Button
        color={themeName == 'light' ? 'secondary' : 'primary' }
        disableElevation
        variant="outlined"
        startIcon={<Icon color={themeName == 'light' ? 'secondary' : 'primary' }>arrow_back</Icon>}
        onClick={aoClicarEmVoltar}
      >
        <Typography variant='button' noWrap color={themeName == 'light' ? 'secondary' : 'primary' }>
          Voltar
        </Typography>
      </Button>
      <Box flex={1} display="flex" justifyContent="end">
        {mostrarBotaoDesativados && (
          <Button
            color="primary"
            disableElevation
            variant="contained"
            startIcon={<Icon>do_disturb</Icon>}
            onClick={aoClicarEmDesativados}
          >
            {textoBotaoDesativados}
          </Button>
        )}
        <Box width={5}></Box>
        {mostrarBotaoNovo && (
          <Button
            color="primary"
            disableElevation
            variant="contained"
            endIcon={<Icon>add</Icon>}
            onClick={aoClicarEmNovo}
          >
            {textoBotaoNovo}
          </Button>
        )}
      </Box>
    </Box>
  );
}
